import { memo } from "react";
import posthog from "posthog-js";
import { PostHogProvider as PostHogProviderComponent } from "@posthog/react";

import { disablePostHog } from "../../constants/app";

if (!disablePostHog) {
   posthog.init(import.meta.env.VITE_POSTHOG_PROJECT_TOKEN, {
      api_host: import.meta.env.VITE_POSTHOG_HOST,
      defaults: "2026-05-30",
      capture_exceptions: true,
   });
}

type PostHogProviderProps = {
   children?: React.ReactNode;
};

function PostHogProvider({ children }: PostHogProviderProps) {
   return <PostHogProviderComponent client={posthog}>{children}</PostHogProviderComponent>;
}

export default memo(PostHogProvider);
